<template>
  <div
    class="py-4 container-fluid min-vh-100 has-isin-info"
    :class="isDarkMode ? 'running-games-page-dark' : ''"
    :style="isDarkMode
      ? 'background: #1E293B !important; min-height: 100vh;'
      : 'min-height: 100vh;'"
  >
    <div class="row">
      <div class="col-lg-12">
        <div class="row d-none d-md-flex isin-info-row">
          <div v-for="stats in ISINStatusInfo" :key="stats.ISINID" class="col-lg-3 col-md-6 col-12">
            <isin-info-card
              :id="stats.ISINID"
              :title="stats.ISINName"
              :isin="stats.ISIN"
              :currency="stats.Currency"
              :price="stats.ISINPriceListPrice"
              :amt-diff="stats.ISINPriceListAmtDiff"
              :pct-diff="stats.ISINPriceListPctDiff"
              :price-change-type="stats.PriceChangeType"
              :icon-change-type="stats.IconChangeType"
              :last-date="stats.LasDate"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-lg-8">
            <div class="row">
              <div
                v-for="game in RunningGames"
                :key="game.GameID"
                class="col-12 mt-2 mb-4"
              >
                <running-game-card
                  :game-id="game.GameID"
                  :game-name="game.GameName"
                  :game-register="game.GameRegister"
                  :game-from="game.GameFrom"
                  :game-to="game.GameTo"
                  :game-text="game.GameText"
                  :game-capital="game.GameCapital"
                  :game-credit="game.GameCredit"
                  :game-rewardImg="game.GameRewardImg"
                  :reward-name="game.RewardName"
                />
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-4 mt-2 mb-4">
            <ActiveGamesSidebar />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import IsinInfoCard from "./components/custom/IsinInfoCard.vue";
import RunningGameCard from "./components/custom/RunningGameCard.vue";
import ActiveGamesSidebar from "./components/custom/ActiveGamesSidebar.vue";

const store = useStore();
const isDarkMode = computed(() => !!store.state.isDarkMode);
const ISINStatusInfo = computed(() => store.state.ISINStatusInfo);
const RunningGames = computed(() => store.state.RunningGame);

store.dispatch('loadISINStatusInfo');
store.dispatch('loadRunningGames');
</script>

<style scoped>
.isin-info-row {
  padding-bottom: 12px;
}

.has-isin-info {
  padding-top: calc(0.75rem * 0.36125) !important;
}
</style>
